export default "__VITE_ASSET__BpQt4WRi__"